<template>
  <div id="table-product">
    <table-component :dataColumn="dataColumn" :isDeleted="true">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" />
        <table-header :title="$t('product.category')" :minWidth="150" />
        <table-header :title="$t('product.subcategory')" :minWidth="150" />
        <table-header :title="$t('product.status')" :minWidth="120" />
        <table-header :title="$t('product.place')" :minWidth="100" />
        <table-header :title="$t('product.marker')" :minWidth="150" />
        <table-header :title="$t('product.productName')" :minWidth="220" />
        <table-header :title="$t('product.modelNumber')" :minWidth="120" />
        <table-header :title="$t('product.years')" :minWidth="80" />
        <table-header :title="$t('product.conditionType')" :minWidth="80" />
        <table-header :title="$t('product.purchasePrice')" :minWidth="150" />
        <table-header :title="$t('product.price')" :minWidth="150" />
        <table-header :title="$t('product.quantity')" :minWidth="80" />
        <table-header :title="$t('product.totalPurchase')" :minWidth="150" />
        <table-header :title="$t('product.note')" :minWidth="200" />
        <table-header :title="$t('product.store')" :minWidth="120" />
        <table-header :title="$t('product.manager')" :minWidth="120" />
        <table-header :title="$t('product.date')" :minWidth="120" />
        <table-header
          fixed="right"
          :title="$t('common.action')"
          :minWidth="80"
        />
      </template>

      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.subcategory.category.name }}</table-cell>
        <table-cell>{{ row.subcategory.name }}</table-cell>
        <table-cell>{{ EStatusProduct.getTitle(row.status) }}</table-cell>
        <table-cell>{{ EPlaceTypeProduct.getTitle(row.placeType) }}</table-cell>
        <table-cell> {{ row.marker }} </table-cell>
        <table-cell>{{ row.name }}</table-cell>
        <table-cell>{{ row.modelNumber }}</table-cell>
        <table-cell> {{ row.yearOfManufacture }} </table-cell>
        <table-cell>
          {{ EConditionTypeProduct.getTitle(row.conditionType) }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.buyPrice) }}{{ $t('common.yen') }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.sellPrice) }}{{ $t('common.yen') }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.quantity) }}
        </table-cell>
        <table-cell>
          {{ formatNumber(row.quantity * row.buyPrice) }}
          {{ $t('common.yen') }}
        </table-cell>
        <table-cell> {{ row.note }} </table-cell>
        <table-cell> {{ row.store.name }} </table-cell>
        <table-cell> {{ row.employee.name }} </table-cell>
        <table-cell> {{ row.date }} </table-cell>

        <table-cell fixed="right">
          <i class="el-icon-view icon" @click="handleDetail(row.id)" />
        </table-cell>
      </template>
    </table-component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import {
  EConditionTypeProduct,
  EStatusProduct,
  EPlaceTypeProduct,
} from '@/enums/product';
import { LIMIT } from '@/constants/common';
import { formatNumber, redirectRouter } from '@/helper';

export default {
  name: 'TableListProduct',
  components: {},
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  data() {
    return {
      productIdSelected: null,
      EConditionTypeProduct,
      EStatusProduct,
      EPlaceTypeProduct,
      LIMIT,
    };
  },
  computed: {
    ...mapGetters('product', ['product']),
  },
  methods: {
    ...mapActions('product', ['getProductList', 'getProductStatistic']),
    formatNumber,

    handleDetail(id) {
      redirectRouter(`/product-history/${id}`);
    },
  },
};
</script>
